<template>
  <div class="w-100 pb-4" style="box-sizing: border-box; ">
    <h3 class="title-2 m-0 mb-3">Visite Photo</h3>
    <div class="d-flex overflow-auto" style="white-space: nowrap;">
      <div v-for="(prestation, index) in prestations" :key="index" class="d-flex align-items-center flex-column me-3">
        <img
          :src="getImageUrl(prestation.picturesAccomodation[0])"
          alt="Miniature of Accommodation"
          class="prestation-image"
          @click="$emit('navigate', prestation.accomodationName)"
        />
        <div class="subcaption prestation-name text-center w-100 mt-2">{{ prestation.accomodationName }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    prestations: Array,
  },
  methods: {
    getImageUrl(image) {
      return image.imgXL || image.imgLarge || image.img;
    },
  },
};
</script>

<style scoped>
::-webkit-scrollbar {
    width: 1px !important; /* Adjust the width as needed */
}

::-webkit-scrollbar-track {
    background-color: #f1f1f1;
    border-radius: 10px; /* Adjust the border radius */
}

::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 10px; /* Adjust the border radius */
}

.prestation-image {
  cursor: pointer;
  width: 125px;
  height: 125px;
  object-fit: cover;
  border-radius: 8px;
}

.prestation-name {
  word-wrap: break-word;
  white-space: normal;
}
</style>
